import { Typography, TextField, styled } from '@mui/material'
import { IRuleset } from '@/types'
import { ITableColumn } from '@/components/UI/DataTable/TableHead'
import { Chip } from '../UI/Chip'

export const columns: ITableColumn<IRuleset>[] = [
  {
    key: "ruleType",
    id: "ruleType",
    minWidth: "250px",
    label: "Rule ID",
    render: (value = "") => <StyledText>{value}</StyledText>,
  },
  {
    key: "description",
    id: "description",
    minWidth: "360px",
    label: "Rule Description",
    render: (value = "") => <StyledText>{value}</StyledText>,
  },
  {
    key: "value",
    id: "value",
    minWidth: "200px",
    label: "Metric",
    render: (value = "") => <StyledText>{value}</StyledText>,
  },
  {
    key: "threshold",
    id: "threshold",
    minWidth: "200px",
    label: "Threshold",
    render: (value = "") => <StyledText>{value}</StyledText>,
  },
  {
    key: "systemOutcome",
    id: "systemOutcome",
    minWidth: "180px",
    label: "System Outcome",
    render: (value = "") => <Chip value={value.toUpperCase()} />,
  },
  {
    key: "supportOutcome",
    id: "supportOutcome",
    minWidth: "180px",
    label: "Agent Outcome",
    render: (value = "") => (
      <StyledTextField
        id="outlined-basic"
        variant="outlined"
        value={value}
        onChange={() => {}}
      />
    ),
  },
  {
    key: "finalOutcome",
    id: "finalOutcome",
    minWidth: "180px",
    label: "Final Outcome",
    render: (value = "") => <Chip value={value.toUpperCase()} />,
  },
]

const StyledText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  textAlign: 'left',
  color: theme.palette.secondary.main,
}))

const StyledTextField = styled(TextField)(({theme}) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
    "& .MuiInputBase-input": {
      color: theme.palette.secondary.main,
      padding: "8px 0px",
    },
  },
}))